import {
  RecordLine,
  RecordModel,
  RecordProperties,
} from './../../../record-model';
import { ModuleStructure } from './../../../../models/module-structure';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from 'src/app/layout/layout.service';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-inbound-serial',
  templateUrl: './inbound-serial.component.html',
  styleUrls: ['./inbound-serial.component.less'],
})
export class InboundSerialComponent implements OnInit {
  @Input() binActivated = false;
  @Input() binLocations = [];
  @Input() selectedBinLocation: any;
  @Input() requiredQty = 0;
  @Input() requiredSerialQty = 0;
  @Input() moduleStructure: ModuleStructure;
  @Input() qtyProperty: RecordProperties;
  @Input() unitsOfMeasurmentProperty: RecordProperties;
  @Input() wareHouseCode: string;
  @Input() recordModel: RecordModel;
  @Input() recordLine: RecordLine;

  @Input() serialNumbers = [];
  @Output() serialNumbersChange = new EventEmitter();

  @Input() selectedSSCC = '';
  @Output() selectedSSCCChange = new EventEmitter();

  @Input() selectedQty = 0;
  @Output() selectedQtyChange = new EventEmitter<number>();

  displayMode = true;
  scannedSerial = '';
  scanMode = true;
  dataDisplayMode = '';
  scannedQuantity = null;
  ssccHidden = g.ssccHidden;

  constructor(
    private messageService: NzMessageService,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.displayMode = localStorage.getItem('serialDisplayMode') === 'true';
    if (this.displayMode === undefined || this.displayMode === null) {
      this.displayMode = true;
    }

    this.scanMode = localStorage.getItem('serialScanMode') === 'true';
    if (this.scanMode === undefined || this.scanMode === null) {
      this.scanMode = true;
    }

    this.dataDisplayMode = localStorage.getItem('serialDataDisplayMode');
    if (
      this.dataDisplayMode === '' ||
      this.dataDisplayMode === undefined ||
      this.dataDisplayMode === null
    ) {
      this.dataDisplayMode = 'C';
    }
  }

  dataDisplayModeChange() {
    localStorage.setItem('serialDataDisplayMode', this.dataDisplayMode);
  }

  displayModeChange() {
    localStorage.setItem('serialDisplayMode', this.displayMode.toString());
  }

  scanModeChange() {
    this.scannedSerial = '';
    this.scannedQuantity = null;
    localStorage.setItem('serialScanMode', this.scanMode.toString());
  }

  serialScanned() {
    this.addNewSerial();
  }

  updateSerialDamaged(serialNumber) {
    if (this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF') {
      return;
    }

    let damaged = false;
    this.serialNumbers.forEach((batch) => {
      if (batch.Damaged) {
        damaged = true;
        return;
      }
    });
    this.recordLine.Properties.find(
      (p) => p.Name === 'U_ITEM_STATUS',
    ).ValueAsObject = damaged ? 'D' : 'F';

    this.recordLine.Properties.find((p) => p.Name === 'U_ITEM_STATUS').Value =
      damaged ? 'D' : 'F';

    this.layoutService.triggerFieldValueChanged({
      recordProperty: this.recordLine.Properties.find(
        (p) => p.Name === 'U_ITEM_STATUS',
      ),
      formId: '',
      line: this.recordLine.Id,
      recordModel: this.recordModel,
      sectionTagName: 'ITM_OFF_LOAD_LINE',
      moduleStructure: this.moduleStructure,
    });

    //U_ITEM_STATUS
  }

  deleteSerial(batchNumber) {
    this.serialNumbers = this.serialNumbers.filter((b) => b !== batchNumber);

    this.selectedQty = this.serialNumbers.length;
    this.serialNumbersChange.emit(this.serialNumbers);
    this.selectedQtyChange.emit(this.selectedQty);
  }

  selectedBinChanged() {
    if (
      this.scannedSerial != null &&
      this.scannedSerial !== undefined &&
      this.scannedSerial !== ''
    ) {
      this.addNewSerial();
    }
  }

  addNewSerial() {
    if (this.scannedSerial === '' && this.scanMode) {
      return;
    }

    if (
      this.serialNumbers.length >= this.requiredSerialQty &&
      this.requiredSerialQty != 0 &&
      !this.qtyProperty.IsNew &&
      this.moduleStructure.module.TableName !== 'OINC' &&
      this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF'
    ) {
      /*this.messageService.error(
        this.layoutService.translate(
          'Selected quantity exceeds the required quantity, we reset the quantity to the maximum allowed quantity.'
        )
      );*/

      this.requiredSerialQty = this.serialNumbers.length;
      return;
    }

    //check if already exist in DB or in the old serial
    const existingSerial = this.serialNumbers.find((sn) => {
      if (sn.ManufacturerSerialNumber === this.scannedSerial) {
        return sn;
      }
    });
    if (existingSerial !== undefined) {
      this.messageService.error(
        this.layoutService.translate('The scanned Serial is already scanned'),
      );
      this.playErrorVoice();
      return;
    }

    if (
      this.binActivated &&
      (this.selectedBinLocation == null ||
        this.selectedBinLocation === undefined ||
        this.selectedBinLocation === '')
    ) {
      this.messageService.error(
        this.layoutService.translate('You should choose the bin location'),
      );
      this.playErrorVoice();
      return;
    }

    this.layoutService
      .executeQuery(2795, {
        scan: this.scannedSerial,
        WhsCode:
          this.moduleStructure.module.ObjectType !== 'InventoryCounting'
            ? ''
            : this.wareHouseCode,
      })
      .subscribe((d) => {
        if (
          d[0].Value != 0 &&
          this.moduleStructure.module.ObjectType !== 'InventoryCounting' &&
          this.moduleStructure.module.ObjectType !== 'oReturns'
        ) {
          this.messageService.error(
            this.layoutService.translate(
              'The scanned Serial is already exist in the database',
            ),
          );
          this.playErrorVoice();
          return;
        } else if (
          d[0].Value == 0 &&
          this.moduleStructure.module.ObjectType === 'InventoryCounting'
        ) {
          /*this.messageService.error(
            this.layoutService.translate(
              'The scanned Serial is not exist in the database'
            )
          );
          this.playErrorVoice();
          return;*/
          const serialToAdd = {
            BinLocation: this.selectedBinLocation,
            U_ITM_WMS_SSCC: this.selectedSSCC,
            ManufacturerSerialNumber: this.scannedSerial,
            InternalSerialNumber: this.scannedSerial,
            Quantity: 1,
          };

          this.serialNumbers = [...this.serialNumbers, serialToAdd];
          this.scannedSerial = '';
          this.scannedQuantity = null;

          //this.selectedQty = this.serialNumbers.length;
          if (
            this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
            this.qtyProperty.IsNew
          ) {
            this.selectedQty += 1;
          } else {
            this.selectedQty =
              (this.serialNumbers.length / this.requiredSerialQty) *
              this.requiredQty;
          }
          this.serialNumbersChange.emit(this.serialNumbers);
          this.selectedQtyChange.emit(this.selectedQty);

          if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
            this.qtyProperty.ValueAsObject = this.selectedQty;
          }

          if (
            this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF' &&
            this.selectedQty === this.requiredQty &&
            !this.qtyProperty.IsNew
          ) {
            // this.qtyProperty.ValueAsObject = this.selectedQty;
            const scope = this;
            this.qtyProperty.DialogVisible = false;
            setTimeout(() => {
              scope.qtyProperty.DialogVisibleDrawerInitialized = false;
            }, 50);
          }
        } else {
          const serialToAdd = {
            BinLocation: this.selectedBinLocation,
            U_ITM_WMS_SSCC: this.selectedSSCC,
            ManufacturerSerialNumber: this.scannedSerial,
            InternalSerialNumber: this.scannedSerial,
            Quantity: 1,
          };

          this.serialNumbers = [...this.serialNumbers, serialToAdd];
          this.scannedSerial = '';
          this.scannedQuantity = null;

          //this.selectedQty = this.serialNumbers.length;
          if (
            this.moduleStructure.module.ObjectType === 'InventoryCounting' ||
            this.qtyProperty.IsNew
          ) {
            this.selectedQty += 1;
          } else {
            this.selectedQty =
              (this.serialNumbers.length / this.requiredSerialQty) *
              this.requiredQty;
          }
          this.serialNumbersChange.emit(this.serialNumbers);
          this.selectedQtyChange.emit(this.selectedQty);
          if (this.recordModel.ObjectKey === 'ITM_OFF_LOAD_DEF') {
            this.qtyProperty.ValueAsObject = this.selectedQty;
          }
          if (
            this.recordModel.ObjectKey !== 'ITM_OFF_LOAD_DEF' &&
            this.selectedQty === this.requiredQty &&
            !this.qtyProperty.IsNew
          ) {
            // this.qtyProperty.ValueAsObject = this.selectedQty;
            const scope = this;
            this.qtyProperty.DialogVisible = false;
            setTimeout(() => {
              scope.qtyProperty.DialogVisibleDrawerInitialized = false;
            }, 50);
          }
        }
      });
  }

  playErrorVoice() {
    const audio = new Audio('assets/audio_file.mp3');
    audio.load();
    audio.play();
  }
}
